import api from './client';
import { getOAuthCallbackOrigin } from './client';

// Xero bank-account mapping + accounting-reconciliation pull (Phase 2B):
// display/ranking-boost only, never auto-confirm -- see
// services/xero_accounting_reconciliation.py.
export const xeroBankFeedAPI = {
  listEntities: () => api.get('/admin/xero-bankfeed/entities'),
  listMappings: () => api.get('/admin/xero-bankfeed/mappings'),
  listInternalAccounts: (entityId) =>
    api.get('/admin/xero-bankfeed/internal-accounts', { params: { entity_id: entityId || undefined } }),
  listXeroAccounts: (entityId) =>
    api.get('/admin/xero-bankfeed/xero-accounts', { params: { entity_id: entityId } }),
  createMapping: (body) => api.post('/admin/xero-bankfeed/mappings', body),
  deactivateMapping: (mappingId) =>
    api.post(`/admin/xero-bankfeed/mappings/${mappingId}/deactivate`),
  runNow: (mappingId) =>
    api.post(`/admin/xero-bankfeed/mappings/${mappingId}/sync`),
  runNowJobStatus: (jobId) =>
    api.get(`/admin/xero-bankfeed/run-now/job-status/${jobId}`),
  listRuns: (entityId, limit = 50) =>
    api.get('/admin/xero-bankfeed/runs', { params: { entity_id: entityId || undefined, limit } }),
  matchTraceStart: (mappingId, sampleSize) =>
    api.post(`/admin/xero-bankfeed/mappings/${mappingId}/match-trace/start`, null, {
      params: { sample_size: sampleSize || undefined },
    }),
  matchTraceJobStatus: (jobId) =>
    api.get(`/admin/xero-bankfeed/match-trace/job-status/${jobId}`),
  matchTraceJobLatest: (mappingId) =>
    api.get(`/admin/xero-bankfeed/mappings/${mappingId}/match-trace/job-latest`),
  migrateAccountIdsPreview: () =>
    api.get('/admin/xero-bankfeed/mappings/migrate-account-ids/preview'),
  migrateAccountIdsApply: () =>
    api.post('/admin/xero-bankfeed/mappings/migrate-account-ids/apply'),
};

// Xero API
export const xeroAPI = {
  getStatus: () => api.get('/integrations/xero/status'),
  initiateAuth: () => api.get('/integrations/xero/auth', {
    params: { origin: getOAuthCallbackOrigin() },
  }),
  disconnect: () => api.delete('/integrations/xero/disconnect'),
  sync: () => api.post('/integrations/xero/sync'),
  syncStatus: () => api.get('/integrations/xero/sync/status'),
  tenantCoverage: () => api.get('/integrations/xero/sync/tenant-coverage'),
  previewBackfill: (tenantNames) =>
    api.post('/admin/diagnostics/xero-invoice-sync/backfill', { tenant_names: tenantNames || null, dry_run: true }),
  applyBackfill: (tenantNames) =>
    api.post('/admin/diagnostics/xero-invoice-sync/backfill', { tenant_names: tenantNames || null, dry_run: false }),
  syncReconciliation: () => api.post('/integrations/xero/sync-reconciliation'),
  getSyncHistory: (limit = 10) => api.get('/integrations/xero/sync-history', { params: { limit } }),
  sendBookkeeperReport: (recipientEmail, googleAccountId) =>
    api.post('/integrations/xero/bookkeeper-report', null, {
      params: { recipient_email: recipientEmail, ...(googleAccountId ? { google_account_id: googleAccountId } : {}) },
    }),
  saveCredentials: (clientId, clientSecret, confirmOverwrite = false) =>
    api.post('/integrations/xero/credentials', {
      client_id: clientId,
      client_secret: clientSecret,
      confirm_overwrite: confirmOverwrite,
    }),
};

// Xero Credit Notes (ACCRECCREDIT/ACCPAYCREDIT) -- ingestion + linkage
// display only, standalone from xeroAPI's invoice sync. See
// services/xero_creditnote_sync.py.
export const xeroCreditNotesAPI = {
  sync: () => api.post('/admin/diagnostics/xero-creditnotes/sync'),
  syncStatus: () => api.get('/admin/diagnostics/xero-creditnotes/sync/status'),
  tenantCoverage: () => api.get('/admin/diagnostics/xero-creditnotes/sync/tenant-coverage'),
  previewBackfill: (tenantNames) =>
    api.post('/admin/diagnostics/xero-creditnotes/backfill', { tenant_names: tenantNames || null, dry_run: true }),
  applyBackfill: (tenantNames) =>
    api.post('/admin/diagnostics/xero-creditnotes/backfill', { tenant_names: tenantNames || null, dry_run: false }),
  card: () => api.get('/admin/diagnostics/xero-creditnotes/card'),
};
